/**
 * `data-*` attributes on `<Drawer.SwipeArea>`. 1:1 port of React's
 * `DrawerSwipeAreaDataAttributes`.
 */
export const DrawerSwipeAreaDataAttributes = {
	open: "data-open",
	closed: "data-closed",
	disabled: "data-disabled",
	swipeDirection: "data-swipe-direction",
	swiping: "data-swiping",
} as const;
